import styled from "styled-components";

export const FooterBar = styled.div`
  position: fixed;
  bottom: 0px;
  left: 0px; 
  width: 100%;
  height: 32px;
  background: #B1B1B1 0% 0% no-repeat padding-box;
  box-shadow: 0px 1px 4px #00000029;
  opacity: 1;
`;

export const CopyRightContainer = styled.div`
  bottom: 8px;
  width: fit-content;
  margin: auto;
  height: fit-content;
  text-align: left;
  display: flex;
`;

export const CopyRightItem = styled.div`
  font: normal normal normal 13px/15px Open Sans;
  color: #006F35;
  padding-top: 8px;
`;

